import React, { FC } from 'react'

import { IconRoamingProps } from './IconRoaming.types'
import * as Styled from './styles/IconRoaming.style'

import { nonThemeableRules } from '../../ruleSet'

const IconRoaming: FC<IconRoamingProps> = ({
  size = nonThemeableRules.defaultSize as number as IconRoamingProps['size'],
  isResponsive = false,
}: IconRoamingProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m20.625 18.565-8.4 2.975-4.113-2.325a2.152 2.152 0 0 0-1.642-.095l-1.5.633 3.25 4c2.393 2.867 5.935 4.77 9.46 3.542l19.657-6.92c4.388-1.78 5.158-3.865 5.708-5.977-1.75-1.313-3.73-2.898-8.065-1.316l-7.382 2.785'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M23.025 20.46 14.6 11.9l2.348-.818a2.5 2.5 0 0 1 1.937.128l12.09 6.462'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M6.975 37.038h34.087' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconRoaming
